// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface TilesIconSignature {
  Element: SVGSVGElement;
}

export const TilesIcon: TOC<TilesIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 11H11V2H2V11ZM4 4H9V9H4V4ZM2 22H11V13H2V22ZM4 15H9V20H4V15ZM22 11H13V2H22V11ZM20 4H15V9H20V4ZM13 22H22V13H13V22ZM15 15H20V20H15V15Z"/>
</svg>
</template>;